import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ChannelsService } from 'src/app/services/channels.service';
import { MediaSummary } from '../../models';

@Component({
	selector: 'app-continue-watching',
	templateUrl: './continue-watching.component.html',
	styleUrls: ['./continue-watching.component.scss']
})
export class ContinueWatchingComponent implements OnInit {

	mediaList: MediaSummary[];
	mediaList2: MediaSummary[] = [{}, {}, {}, {}, {}, {}, {}];

	loaded: boolean = false;

	@Input() currentFocus = false;

	@Output() rowFocused = new EventEmitter<void>();

	constructor(private channelService: ChannelsService) {
	}

	ngOnInit(): void {
		this.channelService.userChannels().subscribe(res => {
			if (res) {
				this.mediaList = null;
				setTimeout(() => {
					this.mediaList = res.find(f => f.type === 'continue-watching').media;
				})
				this.mediaList2 = null;
			}
		});
		this.channelService.refreshUserChannels();
	}
}
